export enum OpenStatusEnum {
    SOON = '-1',
    OPEN = '1',
    CLOSED = '0',
}
